export const TEXTS = {
  CONTINUE_TO_CHECKOUT: 'Proceed to Buy',
  VIEW_DETAILS: 'View Details',
  CONTINUE_TO_PAYMENT: 'Proceed to Pay',
  REWARDS_TEXT_SAVED: 'You saved ',
  REWARDS_TEXT_PURCHASE: ' on this purchase',
  PLEAESE_SELECT_ATLEAST_ONE_ITEM: 'Please select at least one item to proceed',
  SAVING_TEXT: "You're saving ",
  HURRY_SALE_ENDS_IN: ' Hurry! Sale ends in ',
};

export const SCREEN_TYPES = {
  CART: 'cart',
  ADDRESS: 'address',
};

export const FREE_GIFT_SESSION_KEY = 'freeGiftsNudgeShown';
